var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key},[_c('UserView',{attrs:{"editing":true,"inputs":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }